import { useState } from 'react';

import { Accordion } from '@/hen-ui/shadcn/accordion';

import { CareerExplorerRecommendationCard } from './CareerExplorerRecommendationCard';
import type { CareerExplorerRecommendation } from './types';

interface CareerExplorerRecommendationListProps {
  programs: CareerExplorerRecommendation[];
}

export const CareerExplorerRecommendationList = ({
  programs,
}: CareerExplorerRecommendationListProps) => {
  const [openProgramId, setOpenProgramId] = useState(programs[0]?.id ?? '');

  return (
    <Accordion
      type='single'
      collapsible
      value={openProgramId}
      onValueChange={setOpenProgramId}
      className='gap-md'
    >
      {programs.map((program) => (
        <CareerExplorerRecommendationCard key={program.id} program={program} />
      ))}
    </Accordion>
  );
};
